import { atom } from "recoil";

const sigmaState = atom({
  key: "sigmaState",
  default: null,
});

export default sigmaState;
